import type { CardDesignTokens } from '@primeuix/themes/types/card';

 export default {
    body: {
        gap: "1.5rem",
        padding: "1.25rem"
    },
    root: {
        color: "{content.color}",
        shadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1),0 1px 2px -1px rgba(0, 0, 0, 0.1)",
        background: "{content.background}",
        borderRadius: "{border.radius.lg}"
    },
    title: {
        fontSize: "1.25rem",
        fontWeight: "{font.weight.medium}"
    },
    caption: {
        gap: "0rem"
    },
    subtitle: {
        color: "{text.muted.color}"
    }
} satisfies CardDesignTokens;